import {Text} from "@mantine/core";
import {PropsWithChildren} from 'react'

export function NormalText(props: PropsWithChildren) {
    return (
        <Text style={{letterSpacing: "1px"}}>
            {props.children}
        </Text>
    );
}